import Form from "JS/form/Form";
import { notice } from 'JS/utils/notice';

export default class ApplyGetCource {
    form;
    formContainer;
    offers;

    isLoading = false;

    loaderDelay = 200;

    constructor(form) {
        this.form = new Form(form);
        this.formBtnSubmit = form.querySelector('.signup-form__submit');
        this.formContainer = form.parentNode;
        this.offers = this.formContainer.querySelector('input[name="selected_offers"]');
        this.initListeners();
    }

    initListeners() {
        this.form.on('submit', (data) => {
            if (this.isLoading) {
                return;
            }

            this.fetchData(data);
        });
    }

    fetchData(data) {
        this.isLoading = true;

        // почему-то не забирает свежее значение из hidden поля input[name="selected_offers"]. Добавил перед отправкой формы.
        data.selected_offers = this.offers.value;

        const formData = new FormData();

        Object.keys(data).forEach(key => {
            formData.append(key, data[key]);
        });

        formData.append('action', 'apply_getcource');

        this.formBtnSubmit.classList.add('processing');

        setTimeout(() => {
            fetch(backendData.ajaxUrl, {
                method: "POST",
                body: formData,
            })
            .then((res) => res.json())
            .then((data) => {
                this.isLoading = false;

                if (data.success) {

                    this.formContainer.classList.add('success');

                    const notice = this.formContainer.querySelector('.signup-wrapper__notice--success a');
                    notice.href = data.data.result_deal.payment_link;

                    setTimeout(() => {
                        this.formBtnSubmit.classList.remove('processing');
                        
                        setTimeout(() => {
                            window.location.href = data.data.result_deal.payment_link;
                        }, 3000);
                        
                    }, 400);

                } else {
                    this.formBtnSubmit.classList.remove('processing');
                    let notice_options = {
                        duration: 4000
                    };
                    if (data.data.need_login) {
                        const login_btn = document.querySelector('[data-open-auth]');
                        if (login_btn) {
                            var clickEvent = new Event('click', {
                                bubbles: true,
                            });
                            login_btn.dispatchEvent(clickEvent);
                            notice_options = {
                                duration: 20000
                            };
                        }
                    }
                    notice(data.data?.message, 'warning', notice_options);
                }
            })
            .catch((error) => {
                this.formBtnSubmit.classList.remove('processing');
                this.isLoading = false;
                notice(error, 'error');
            });

        }, this.loaderDelay);
    }
}